import React from 'react';

import 'components/GMetrixStepper/GMetrixStepper.scss';

type StepChangeEvent = {
    value: number;
};

type GMetrixStepperProps = {
    handleChange: (e: StepChangeEvent) => void;
    linear: boolean;
    mode?: 'steps' | 'labels';
    setStep: React.Dispatch<React.SetStateAction<number>>;
    step: number;
    stepItems: StepItem[];
};

export type StepItem = {
    icon?: string;
    isValid?: boolean;
    label: string;
};

export const GMetrixStepper = (props: GMetrixStepperProps) => {

    const { handleChange, linear, step, stepItems } = props;

    const handleClick = (index: number) => {

        if (linear && index > step + 1) return;

        handleChange({ value: index });

    };

    const handleKeyDown = (e: React.KeyboardEvent, index: number, isDisabled: boolean) => {

        if (isDisabled) return;

        if (e.key === 'Enter' || e.key === ' ') {

            e.preventDefault();
            handleClick(index);

        }

    };

    const getIndicatorClasses = (isActive: boolean, isCompleted: boolean, isInvalid: boolean) => {

        if (isInvalid) return 'bg-danger border-danger text-white';
        if (isActive) return 'bg-primary border-primary text-white';
        if (isCompleted) return 'bg-success border-success text-white';
        return 'bg-white border text-muted';

    };

    const getLabelClasses = (isActive: boolean, isCompleted: boolean) => {

        if (isActive) return 'text-primary font-weight-bold';
        if (isCompleted) return 'text-success';
        return 'text-muted';

    };

    return (
        <div className="gmetrix-stepper d-flex align-items-center justify-content-center flex-wrap py-2">
            {stepItems.map((item, index) => {

                const isActive = index === step;
                const isCompleted = index < step;
                const isInvalid = item.isValid === false;
                const isDisabled = linear && index > step + 1;

                return (
                    <React.Fragment key={index}>
                        {index > 0 && (
                            <div className={`gmetrix-stepper__connector mx-3 mb-4 ${isCompleted ? 'bg-success' : 'bg-light border-top'}`} />
                        )}
                        <div
                            aria-current={isActive ? 'step' : undefined}
                            aria-disabled={isDisabled || undefined}
                            className={`d-flex flex-column align-items-center text-nowrap ${isDisabled ? '' : 'cursor-pointer'}`}
                            onClick={isDisabled ? undefined : () => handleClick(index)}
                            onKeyDown={e => handleKeyDown(e, index, isDisabled)}
                            role="button"
                            style={isDisabled ? { opacity: 0.5, pointerEvents: 'none' } : undefined}
                            tabIndex={isDisabled ? -1 : 0}
                        >
                            <div className={`gmetrix-stepper__indicator d-flex align-items-center justify-content-center rounded-circle font-weight-bold ${getIndicatorClasses(isActive, isCompleted, isInvalid)}`}>
                                {isCompleted && !isInvalid ? '\u2713' : index + 1}
                            </div>
                            <span className={`gmetrix-stepper__label mt-2 small text-center ${getLabelClasses(isActive, isCompleted)}`}>
                                {item.label}
                            </span>
                        </div>
                    </React.Fragment>
                );

            })}
        </div>
    );

};
